import type { GuitarChart } from '../guitarChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_VIOLET } from '../builtinPulseMaps/palettes.js';
import { assembleImportedGuitarChart } from './importedGuitarChart.js';
import normalImported from './imported/heroes-normal.guitar.json' with { type: 'json' };
import hardImported from './imported/heroes-hard.guitar.json' with { type: 'json' };
import extremeImported from './imported/heroes-extreme.guitar.json' with { type: 'json' };

export const HEROES_GUITAR_VARIANTS: Record<Variant, GuitarChart> = assembleImportedGuitarChart({
  baseSlug: 'heroes',
  baseTitle: "Heroes Tonight",
  description: "Janji - Heroes Tonight on a clean 3-diff mania set. Bouncy progressive house, every gem on the vocal hook.",
  difficulty: 3,
  palette: PALETTE_VIOLET,
  audioSrc: '/audio/guitar/heroes.mp3',
  attribution: "\"Heroes Tonight\" by Janji (feat. Johnning) [NCS Release] - https://ncs.io/heroes-tonight",
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
});
